import { CIcon } from '~/icons/types'

export const ciAllMountainBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M18.496 10.547a4.339 4.339 0 0 0-.98.12l-1.447-4.06h1.271a.504.504 0 0 0 .46-.295l.404-.889a.504.504 0 1 0-.918-.417l-.27.594h-1.662a.504.504 0 0 0-.475.673l.677 1.9-5.753 1.01-.562-1.29.576.001h.002a.504.504 0 0 0 .001-1.008L7.48 6.88h-.001a.504.504 0 0 0-.002 1.008l.663.002 1.563 3.59-1.102.682a4.366 4.366 0 1 0 .957 3.263h1.027a1.306 1.306 0 0 0 1.085.603 1.338 1.338 0 0 0 1.34-1.33 1.299 1.299 0 0 0-.084-.416l3.35-4.09.293.824a4.338 4.338 0 1 0 1.927-.468Zm-8.386 1.865.597 1.37a1.33 1.33 0 0 0-.311.634h-.838a4.312 4.312 0 0 0-.409-1.41Zm-1.56 2.004H6.872l1.423-.881a3.326 3.326 0 0 1 .255.88ZM5.238 18.28a3.363 3.363 0 1 1 2.502-5.588L4.835 14.49a.504.504 0 0 0 .265.933h3.45a3.359 3.359 0 0 1-3.312 2.857Zm7.019-4.774a1.303 1.303 0 0 0-.587-.151c-.016 0-.03.009-.046.01l-1.407-3.232 5.472-.962.036.1Zm6.239 4.774a3.352 3.352 0 0 1-1.586-6.31l1.111 3.119a.505.505 0 0 0 .475.335.487.487 0 0 0 .17-.03.505.505 0 0 0 .305-.644l-1.116-3.131a3.362 3.362 0 1 1 .64 6.661Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'all-mountain-bike',
  type: 'thin'
}
